import { Schema } from "effect";
const CursorSchema = Schema.Struct({
    id: Schema.Number
});
const CursorUrlParams = Schema.compose(Schema.StringFromBase64Url, Schema.parseJson(CursorSchema));
export const UrlParams = Schema.Struct({
    limit: Schema.NumberFromString.pipe(Schema.optionalWith({
        default: ()=>100
    })),
    cursor: CursorUrlParams.pipe(Schema.optional)
});
export const Pagination = Schema.Union(Schema.Struct({
    hasMore: Schema.Literal(true),
    cursor: CursorUrlParams
}), Schema.Struct({
    hasMore: Schema.Literal(false),
    cursor: Schema.Null
}));
const PostMedia = Schema.Struct({
    title: Schema.String,
    description: Schema.String,
    contentType: Schema.String,
    fileName: Schema.String,
    url: Schema.String
});
export class Model extends Schema.Class("superwall-api-Blog-Model")({
    object: Schema.Literal("blog_post"),
    title: Schema.String,
    subtitle: Schema.String,
    url: Schema.String,
    slug: Schema.String,
    createdAt: Schema.DateFromString,
    updatedAt: Schema.DateFromString,
    image: Schema.optional(PostMedia),
    author: Schema.optional(Schema.Struct({
        name: Schema.String,
        slug: Schema.optional(Schema.String),
        title: Schema.optional(Schema.String),
        image: Schema.optional(PostMedia),
        email: Schema.optional(Schema.String),
        twitter: Schema.optional(Schema.String),
        linkedin: Schema.optional(Schema.String)
    }))
}) {
}
export class List extends Schema.Class("superwall-api-Blog-List")({
    object: Schema.Literal("list"),
    data: Schema.Array(Model),
    pagination: Pagination
}) {
}
